import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

type ProjectIconProps = SvgIconProps;

export const ProjectIcon: React.FC<ProjectIconProps> = (
  props: ProjectIconProps
) => (
  <SvgIcon {...props}>
    <React.Fragment>
      <path d="M 10,4 H 2.000000000000003 V 20 H 22 V 6 H 12 Z" />
    </React.Fragment>
  </SvgIcon>
);

export default ProjectIcon;
